import { graphql } from "gql";

const JOB_LIST_QUERY = graphql(`
  query JobList {
    jobList {
      ...Job
    }
  }
`);

export default JOB_LIST_QUERY;
